<template>
  <div class="youtaofang">
    <topTitle
      title="柏庭荟"
      :list="list"
      :newData="newData"
      :ContentStatus="ContentStatus"
      :remakTitle="remakTitle"
    ></topTitle>
    <p class="top_p" v-if="ContentStatus == false">
      钱湖柏庭运动俱乐部有3个社团，分别是门球社团、乒乓球社团、台球社团。
    </p>
    <p class="top_p title" style="margin: 0" v-if="ContentStatus == false">
      一、门球社团
    </p>
    <p class="top_p " style="margin: 0" v-if="ContentStatus == false">
      门球运动属于户外运动，场地平坦舒适，长者们每天早上和下午出去练球，既呼吸了新鲜空气又接受了日光浴。
    </p>
    <!-- <div class="item_img">
      <img src="../../assets/image/party/yundong_1.png" alt="" />
    </div> -->
    <p class="top_p" style="margin: 0" v-if="ContentStatus == false">
      抬腿、弯腰、挥棒……一系列的动作下来，既锻炼了眼，活动了四肢，又活动了手指、手腕关节、筋骨，还活动了腰和脚~
    </p>
    <p class="top_p" style="margin: 0" v-if="ContentStatus == false">
      对于大部分长者们来说，可谓一举多得，是一项大有裨益的活动。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/yundong.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0" v-if="ContentStatus == false">
      二、乒乓球社团
    </p>
    <p class="top_p" style="margin: 0" v-if="ContentStatus == false">
      “人生能有几回搏，此时不搏何时搏？”
    </p>
    <p class="top_p" style="margin: 0" v-if="ContentStatus == false">
      作为国球的乒乓球相信没几个人不喜爱的吧，那么，柏庭的乒乓球社团将是众多球友的理想胜地。而乒乓球是一种全身运动、有氧运动，它技术打法丰富多样，既要考虑技术的发挥，又要考虑战术的运用，具有很好的健脑功能。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/yundong_1.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0" v-if="ContentStatus == false">
      三、台球社团
    </p>
    <p class="top_p" style="margin: 0" v-if="ContentStatus == false">
      四方绿台平地起，一杆胜负定乾坤。
    </p>
    <p class="top_p" style="margin: 0" v-if="ContentStatus == false">
      台球是一项在国际上广泛而流行的高雅室内体育运动，柏庭的台球社团便是一个爱好者们交流的平台，在此，会员们将有良好的打球环境，在学习和练习中，不仅能锻炼身体，更能交到许多爱好相同的朋友。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/yundong_2.jpg" alt="" />
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
        {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
        {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
        {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
        {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        },
      ],
      newData: 1,
      list2: [
        {
          img: require("../../assets/image/party/item_1.png"),
        },
        {
          img: require("../../assets/image/party/item_2.png"),
        },
        {
          img: require("../../assets/image/party/item_3.png"),
        },
      ],
      dataContent: "",
      ContentStatus: false,
      remakTitle: "",
    };
  },
  methods: {
    getHtml(e) {
      this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
    },
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {},
};
</script>
<style scoped="scoped">
.title{
  font-weight: 800 !important;
}
p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet {
  display: inline-block;
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #3f674b;
  line-height: 54px;
  text-align: left;
  margin-top: 0.6rem;
  cursor: pointer;
}
.small_jiantou {
  display: inline-block;
  width: 0.1rem;
  height: 0.1875rem;
  background-image: url("../../assets/image/left_item1.png");
  background-size: 100% 100%;
}
.item_jiantou1 {
  margin-left: 0.125rem;
  margin-right: 0.05rem;
}
.item_jiantou2 {
  background-image: url("../../assets/image/left_item2.png");
  background-size: 100% 100%;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
</style>